document.addEventListener('DOMContentLoaded', function() {
    const visibleText = document.getElementById('top-charger-tag-section');
    const hiddenText = document.getElementById('hidden-text');
    let isTooltipVisible = false; // Initialize the state variable

    if (visibleText && hiddenText) {
        visibleText.addEventListener('mouseenter', () => {
            hiddenText.style.display = 'block';
        });

        visibleText.addEventListener('mouseleave', () => {
            hiddenText.style.display = 'none';
        });

        // Click events for touch devices
        visibleText.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent immediate closing
            isTooltipVisible = !isTooltipVisible;
            hiddenText.style.display = isTooltipVisible ? 'block' : 'none';
        });

        // Handle clicking outside to close tooltip
        document.addEventListener('click', (e) => {
            if (isTooltipVisible && !visibleText.contains(e.target) && !hiddenText.contains(e.target)) {
                hiddenText.style.display = 'none';
                isTooltipVisible = false;
            }
        });
    } else {
        console.error("Could not find elements: top-charger-tag-section or hidden-text");
    }
});
